export default __webpack_public_path__ + "static/media/3334 knife block B side.b756c382.png";